module.exports = __webpack_public_path__ + "static/media/RC-animated-400-optimized.059ebfc9.png";